import { isCookieAuthEnabled } from './sessionAuth';
import type { AdminPortalUser } from '../constants/adminPortal';

export const getAdminPortalUser = (): AdminPortalUser | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = localStorage.getItem('adminUser');
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as AdminPortalUser;
  } catch {
    return null;
  }
};

export const persistAdminPortalSession = (
  user: AdminPortalUser,
  token?: string | null,
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const useCookie = isCookieAuthEnabled() || !token || token === 'cookie-session';
  if (!useCookie && token) {
    localStorage.setItem('token', token);
  }
  localStorage.setItem('adminUser', JSON.stringify(user));
};

export const clearAdminPortalSession = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  // Keep shared auth token/cookie preference; only drop portal profile cache.
  localStorage.removeItem('adminUser');
};
